import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  labelBy: {
    key: 'VideoInfo-labelBy',
    defaultValue: 'por',
  },
  labelPublished: ({ date }: { date: string }) => ({
    key: 'VideoInfo-labelPublished',
    parameters: { date },
    defaultValue: 'Publicado em {date}',
  }),
  errorLoadingStatus: {
    key: 'VideoInfo-errorLoadingStatus',
    defaultValue: 'Erro ao carregar status',
  },
  ariaUpdate: {
    key: 'VideoInfo-ariaUpdate',
    defaultValue: 'Atualizar dados do post',
  },
  ariaUpdating: {
    key: 'VideoInfo-ariaUpdating',
    defaultValue: 'Atualizando dados do post',
  },
})
